<div class="modal-container">
  <div class="modal-header">
    <h5 class="modal-title">{{ user.firstName }} {{ user.lastName }}</h5>
  </div>

  <div class="modal-body">
    <div class="user-profile">
      <img
        [src]="user.avatar || 'placeholder_profile.png'"
        class="user-avatar"
      />
      <p class="user-role">{{ USER_ROLE_MAPPING[user.userRole] }}</p>

      <div class="user-contact">
        <div class="contact-item">
          <i class="bi bi-envelope"></i>
          <span>{{ user.email }}</span>
        </div>
        <div class="contact-item">
          <i class="bi bi-telephone"></i>
          <span>{{ user.phone || "No phone number" }}</span>
        </div>
      </div>

      <!-- Password Reset -->
      <button
        class="btn btn-outline-secondary w-100"
        (click)="initiatePasswordReset()"
        *ngIf="!resettingPassword"
      >
        Password Reset
      </button>

      <div *ngIf="resettingPassword">
        <form autocomplete="off">
          <!-- Hidden username field for a11y and browser heuristics -->
          <label for="tempUsername" class="visually-hidden">Username (email)</label>
          <input
            id="tempUsername"
            type="email"
            name="username"
            [value]="user.email"
            autocomplete="username"
            tabindex="-1"
            aria-hidden="true"
            style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0;"
          />
          <div class="form-group password-input">
            <div class="input-container">
              <input
                id="tempabcd"
                [type]="showPassword ? 'text' : 'password'"
                class="form-control"
                placeholder="Create temporary password"
                [(ngModel)]="tempPassword"
                name="tempabcd"
                autocomplete="new-password"
                autocorrect="off"
                autocapitalize="none"
                spellcheck="false"
                minlength="8"
                pattern="^(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$"
                required
                #tempPasswordField="ngModel"
              />
              <i
                class="toggle-password-icon bi"
                [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"
                (click)="togglePasswordVisibility()"
              ></i>
            </div>
          </div>
        </form>

        <div
          class="error-message"
          *ngIf="tempPasswordField.invalid && tempPasswordField.touched"
        >
          <span *ngIf="tempPasswordField.errors?.['required']"
            >Password is required.</span
          >
          <span *ngIf="tempPasswordField.errors?.['minlength']"
            >Password must be at least 8 characters.</span
          >

          <span *ngIf="tempPasswordField.errors?.['pattern']">
            Password must contain at least one uppercase letter, one digit, and one symbol.
          </span>
        </div>
        <button
          class="btn btn-primary confirm-reset-btn w-100 mt-2"
          [disabled]="tempPasswordField.invalid"
          (click)="confirmPasswordReset()"
        >
          @if (loading) {
            <span>
              <i class="spinner-border spinner-border-sm"></i> Resetting...
            </span>
          } @else {
            <span>Confirm Reset</span>
          }
        </button>
      </div>

      <!-- Success Message -->
      <div class="alert alert-success mt-2" *ngIf="successMessage">
        {{ successMessage }}
      </div>

      @if (USER_ROLE_MAPPING[user.userRole] == "Donor") {
        <button
          class="btn w-100 mt-2"
          [ngClass]="
            user.enabled ? 'btn-outline-danger' : 'btn-outline-success'
          "
          (click)="resetDonorQuestionnaire(user)"
        >
          @if (resettingQuestionnaire) {
            <i class="spinner-border spinner-border-sm"></i> Processing...
          } @else {
            <span> Reset Donor Questionnaire </span>
          }
        </button>
      }

      <button
        class="btn w-100 mt-2"
        [ngClass]="user.enabled ? 'btn-outline-danger' : 'btn-outline-success'"
        (click)="toggleUserStatus()"
      >
        @if (loadingStatus) {
          <i class="spinner-border spinner-border-sm"></i> Processing...
        } @else {
          @if (user.userRole == "Donor") {
            <span>
              {{ user.enabled ? "Deactivate Donor" : "Activate Donor" }}
            </span>
          } @else {
            <span>
              {{ user.enabled ? "Deactivate User" : "Activate User" }}
            </span>
          }
        }
      </button>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="closeModal()">Close</button>
  </div>
</div>
